module.exports = __webpack_public_path__ + "img/product4-2.3f6ef35a.jpg";